import { ChallengeService, TaskService } from '@duck/api-definitions'

export type Intensity = 'light' | 'deep'
export type ToolChoice = 'SQL' | 'Python' | 'either'

export interface HelpMePickAnswers {
  intensity: Intensity | null
  tool: ToolChoice | null
  proficiencies: TaskService.TaskProficienciesEnum[]
}

const D = ChallengeService.ChallengeDifficultyEnum
const T = ChallengeService.TimeCategoryEnum

export const INTENSITY_DIFFICULTIES: Record<Intensity, ChallengeService.ChallengeDifficultyEnum[]> = {
  light: [D.Easy, D.Intermediate],
  deep: [D.Hard, D.Expert],
}

// `New` is the lowest time tier (timeCategoryOrder), so it folds into "light".
export const INTENSITY_TIMES: Record<Intensity, ChallengeService.TimeCategoryEnum[]> = {
  light: [T.New, T.UpTo30, T.UpTo60],
  deep: [T.UpTo60, T._60OrMore],
}

export const matchesAnswers = (
  challenge: ChallengeService.AvailableChallenge,
  answers: HelpMePickAnswers,
): boolean => {
  if (answers.intensity !== null) {
    if (!INTENSITY_DIFFICULTIES[answers.intensity].includes(challenge.difficulty)) return false
    if (!INTENSITY_TIMES[answers.intensity].includes(challenge.timeCategory)) return false
  }
  if (answers.tool !== null && answers.tool !== 'either') {
    if (!challenge.allowedWeapons.includes(answers.tool)) return false
  }
  if (answers.proficiencies.length > 0) {
    const have = new Set(challenge.proficiencies ?? [])
    if (!answers.proficiencies.some((p) => have.has(p))) return false
  }
  return true
}

export const filterMatches = (
  challenges: ChallengeService.AvailableChallenge[],
  answers: HelpMePickAnswers,
): ChallengeService.AvailableChallenge[] => challenges.filter((c) => matchesAnswers(c, answers))
